import React, { useState } from 'react'
import Icons from '../../../components/UI/Icons'

const HeaderSection = (props) => {
    const [isNavOpen, setIsNavOpen] = useState(false)
    const { handleLeftClick,
        handleRightClick,
        tabHeaders,
        selectedTab,
        handleTabClick,
        scrollerRef,
        finishedTabs,
        inactiveLeft,
        params, } = props

    const renderTabs = (closeOnSelect = false) => (
        <ul className="nav nav-borders flex-column sh_vertnavbar nav-tabs border-0">
            {tabHeaders.map((header, index) => (
                <li key={index}>
                    <a
                        className={`nav-link ${selectedTab === header.label ? 'active' : ''}`}
                        onClick={() => {
                            handleTabClick(header.label, index)
                            if (closeOnSelect) {
                                setIsNavOpen(false)
                            }
                        }}
                    >
                        {finishedTabs.includes(header.label) === true ? (
                            <span className="mr-2">
                                <Icons type={'Completed'} />
                            </span>
                        ) : (
                            <span className="mr-2">
                                <Icons type={selectedTab === header.label ? 'ActivePlay' : 'Play'} />
                            </span>
                        )}
                        {header.label}
                    </a>
                </li>
            ))}
        </ul>
    )

  return (
      <>
          <div className="d-flex sh_emrresponsivegridleft sh_topNavDesktop">
              {renderTabs(false)}
          </div>

          <button
              type="button"
              className="sh_topNavToggleBtn"
              onClick={() => setIsNavOpen((prevState) => !prevState)}
              aria-label={isNavOpen ? 'Close navigation panel' : 'Open navigation panel'}
          >
              {isNavOpen ? (
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      fill="none"
                      stroke="#141B34"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                  >
                      <path d="M11.5 18C11.5 18 5.50001 13.5811 5.5 12C5.49999 10.4188 11.5 6 11.5 6" />
                      <path d="M18.5 18C18.5 18 12.5 13.5811 12.5 12C12.5 10.4188 18.5 6 18.5 6" />
                  </svg>
              ) : (
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                  >
                      <path d="M12.5 18C12.5 18 18.5 13.5811 18.5 12C18.5 10.4188 12.5 6 12.5 6" />
                      <path d="M5.50005 18C5.50005 18 11.5 13.5811 11.5 12C11.5 10.4188 5.5 6 5.5 6" />
                  </svg>
              )}
          </button>

          <div
              className={`sh_topNavBackdrop ${isNavOpen ? 'show' : ''}`}
              onClick={() => setIsNavOpen(false)}
          />

          <div className={`sh_topNavOffcanvas ${isNavOpen ? 'open' : ''}`}>
              <div className="sh_topNavOffcanvasHeader">
                  <button
                      type="button"
                      className="sh_topNavCloseBtn"
                      onClick={() => setIsNavOpen(false)}
                      aria-label="Close navigation panel"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="currentColor" fill="none" stroke="#141B34" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M18 6L6.00081 17.9992M17.9992 18L6 6.00085" />
                    </svg>
                  </button>
              </div>
              <div className="sh_topNavOffcanvasBody">{renderTabs(true)}</div>
          </div>
      </>
  )
}

export default HeaderSection